import axios from 'axios'

export default {
    get: () => axios.get('roles'),
    store: (data) => axios.post('roles/store', data),
    update: (data) => axios.post('roles/update', data),
    delete: (id) => axios.post('roles/delete', id),
    getRolePermissions: () => axios.get('roles/permissions'),
    getPermissions: () => axios.get('permissions')
}